import React from 'react';
import classNames from 'classnames';

import ProfileRing from '../ProfileRing';
import SubtleButton from '../SubtleButton';
import styles from './UserDetails.module.scss';
import {UserStatus} from '../../types';

export interface Props {
  mainText?: string;
  profilePhoto: string;
  headerText?: string;
  subtitleText?: string;
  status?: UserStatus;
  disclosure?: boolean;
  shrink?: boolean;
  onClick?(): void;
}

export default function UserDetails({
  mainText,
  profilePhoto,
  headerText,
  subtitleText,
  status,
  disclosure,
  shrink,
  onClick,
}: Props) {
  const disclosureClassName = classNames(styles.Disclosure);

  const handleActivatorClick = () => {
    onClick && onClick();
  };

  const hasBlueHighlight =
    status === UserStatus.Hosting || status === UserStatus.Connected;

  const hasGreenHighlight =
    status === UserStatus.Listening || status === UserStatus.Idle;

  const hasGreyHighlight = status === UserStatus.Offline;

  const mainTextClassName = classNames(
    styles.MainText,
    (!headerText || !subtitleText) && styles.larger,
  );

  const badgeClassName = classNames(
    styles.Badge,
    hasBlueHighlight && styles.connected,
    hasGreenHighlight && styles.listening,
    hasGreyHighlight && styles.idle,
  );

  return (
    <div className={styles.UserDetails}>
      <SubtleButton onClick={handleActivatorClick} shrink={shrink}>
        <div className={styles.UserDetailsWrapper}>
          <div className={styles.PhotoWrapper}>
            <ProfileRing
              photo={profilePhoto}
              color={getProfileRingColor(
                hasBlueHighlight,
                hasGreenHighlight,
                hasGreyHighlight,
              )}
            />
            {(hasBlueHighlight || status === UserStatus.Listening) && (
              <div className={badgeClassName} />
            )}
          </div>
          <div
            className={classNames(
              styles.Content,
              !mainText && styles.minimized,
              disclosure && styles.disclosure,
            )}
          >
            <span className={styles.HeaderText}>{headerText}</span>
            <div className={mainTextClassName}>{mainText}</div>
            <span className={styles.SubtitleText}>{subtitleText}</span>
          </div>
          {disclosure && <div className={disclosureClassName} />}
        </div>
      </SubtleButton>
    </div>
  );
}

function getProfileRingColor(blue: boolean, green: boolean, grey: boolean) {
  if (blue) {
    return 'blue';
  } else if (green) {
    return 'green';
  } else if (grey) {
    return 'black';
  }
}
